export const weather = (t) =>{
    return({
        type: 'STORE_WEATHER',
        payload: t,
    });
}